(function () {
  function placeThumb(box, thumb, label, animate) {
    if (!label) return;
    if (!animate) box.classList.add('dragging');
    thumb.style.width = label.offsetWidth + 'px';
    thumb.style.transform = 'translateX(' + label.offsetLeft + 'px)';
    if (!animate) {
      void thumb.offsetWidth;
      box.classList.remove('dragging');
    }
  }

  function formatPrice(cents) {
    var euros = (cents / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return euros + ' €';
  }

  function initQuantity(fieldset, priceCells, getActiveIndex) {
    var qtyBox = fieldset.querySelector('.gram-quantity');
    if (!qtyBox || qtyBox.dataset.qtyReady) return null;
    qtyBox.dataset.qtyReady = '1';

    var display = qtyBox.querySelector('[data-qty-display]');
    var totalEl = qtyBox.querySelector('[data-qty-total]');
    var minusBtn = qtyBox.querySelector('[data-step="-1"]');
    var plusBtn = qtyBox.querySelector('[data-step="1"]');

    var fallbackPrice = (function () {
      if (!totalEl) return 0;
      var text = totalEl.textContent.replace(/[^\d,.-]/g, '').replace(',', '.');
      var n = parseFloat(text);
      return Number.isFinite(n) ? Math.round(n * 100) : 0;
    })();

    function getActiveUnitPriceCents() {
      var idx = typeof getActiveIndex === 'function' ? getActiveIndex() : -1;
      if (idx >= 0 && priceCells[idx]) {
        var cents = parseInt(priceCells[idx].dataset.priceCents || '', 10);
        if (Number.isFinite(cents)) return cents;
      }
      return fallbackPrice;
    }

    function getFormQtyInput() {
      var section = fieldset.closest('section, .shopify-section') || document;
      return section.querySelector('input.quantity__input[name="quantity"]');
    }

    function setQty(newQty, flash) {
      newQty = Math.max(1, Math.floor(newQty));
      qtyBox.dataset.qty = String(newQty);
      if (display) display.textContent = String(newQty);
      if (minusBtn) {
        minusBtn.disabled = newQty <= 1;
        minusBtn.classList.toggle('is-disabled', newQty <= 1);
      }

      if (totalEl) {
        var total = getActiveUnitPriceCents() * newQty;
        totalEl.textContent = formatPrice(total);
        if (flash) {
          totalEl.classList.remove('hb-price-flash');
          void totalEl.offsetWidth;
          totalEl.classList.add('hb-price-flash');
        }
      }

      var formInput = getFormQtyInput();
      if (formInput && parseInt(formInput.value, 10) !== newQty) {
        formInput.value = String(newQty);
        formInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function step(delta) {
      var current = parseInt(qtyBox.dataset.qty || '1', 10) || 1;
      setQty(current + delta, true);
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { step(-1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { step(1); });

    setQty(parseInt(qtyBox.dataset.qty || '1', 10) || 1, false);

    return {
      refresh: function (flash) {
        var current = parseInt(qtyBox.dataset.qty || '1', 10) || 1;
        setQty(current, flash);
      },
    };
  }

  function init(box) {
    if (box.dataset.pillsReady) return;
    box.dataset.pillsReady = '1';

    var labels = Array.prototype.slice.call(box.querySelectorAll('.gram-pill'));
    if (!labels.length) return;

    var fieldset = box.closest('.product-form__input--pill');
    var priceCells = fieldset
      ? Array.prototype.slice.call(fieldset.querySelectorAll('.gram-price'))
      : [];
    var inputs = Array.prototype.slice.call(box.querySelectorAll('input[type="radio"]'));

    var thumb = document.createElement('span');
    thumb.className = 'gram-thumb';
    box.insertBefore(thumb, box.firstChild);

    function syncActivePrice(idx) {
      if (!priceCells.length) return;
      priceCells.forEach(function (cell, i) {
        cell.classList.toggle('is-active', i === idx);
      });
    }

    function syncActiveLabel(idx) {
      labels.forEach(function (label, i) {
        label.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
      });
    }

    function getCheckedIndex() {
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) return i;
      }
      return 0;
    }

    var currentIdx = getCheckedIndex();

    function getCurrentIdx() { return currentIdx; }

    var qty = fieldset ? initQuantity(fieldset, priceCells, getCurrentIdx) : null;

    function visualUpdate(idx, animate) {
      if (idx < 0 || idx >= labels.length) return;
      currentIdx = idx;
      placeThumb(box, thumb, labels[idx], animate);
      syncActiveLabel(idx);
      syncActivePrice(idx);
      if (qty) qty.refresh(false);
    }

    function pillAtX(clientX) {
      for (var i = 0; i < labels.length; i++) {
        var r = labels[i].getBoundingClientRect();
        if (clientX >= r.left - 1 && clientX <= r.right + 1) return i;
      }
      var boxRect = box.getBoundingClientRect();
      return clientX < boxRect.left ? 0 : labels.length - 1;
    }

    requestAnimationFrame(function () { visualUpdate(currentIdx, false); });
    window.addEventListener('resize', function () {
      placeThumb(box, thumb, labels[currentIdx], false);
    });

    // — Drag interaction — pointer events with capture, like the home card
    var dragging = false;
    var dragStartX = 0;
    var dragMoved = false;
    var pointerId = null;

    box.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      // Don't start drag if user taps a disabled label
      var label = e.target.closest && e.target.closest('.gram-pill');
      if (label && label.classList.contains('gram-pill--disabled')) return;

      dragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      pointerId = e.pointerId;
      try { box.setPointerCapture(pointerId); } catch (_) {}
      box.classList.add('dragging');
    });

    box.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      if (Math.abs(e.clientX - dragStartX) > 3) dragMoved = true;
      visualUpdate(pillAtX(e.clientX), false);
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      box.classList.remove('dragging');
      try { box.releasePointerCapture(pointerId); } catch (_) {}

      var idx = pillAtX(e.clientX);
      visualUpdate(idx, true);

      // Always trigger the change manually (drag OR tap). With setPointerCapture
      // active during pointerdown, the synthesized click on the label can fail to
      // toggle the radio on some touch devices, leaving the cart with the initial
      // variant. We disable the native click below to avoid double-fire.
      if (idx !== getCheckedIndex()) {
        var input = inputs[idx];
        if (input && !input.disabled) {
          inputs.forEach(function (other) { other.checked = false; });
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      setTimeout(function () { dragMoved = false; }, 0);
    }

    box.addEventListener('pointerup', endDrag);
    box.addEventListener('pointercancel', endDrag);

    // The radio toggle is handled in endDrag — block the native click on the
    // label so we don't fire the change event twice.
    labels.forEach(function (label) {
      label.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    // For simple taps (no drag), update visuals immediately on radio change
    // — the AJAX swap may take a moment, but the user sees the right pill highlighted.
    inputs.forEach(function (input, i) {
      input.addEventListener('change', function () {
        if (input.checked && currentIdx !== i) {
          visualUpdate(i, true);
        }
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.product-form__input--pill .gram-pills').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      requestAnimationFrame(function () { initAll(); });
    });
  }
})();
